import classNames from 'classnames/bind';
import styles from './Book.module.css';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  groupProjectIdChanged,
  myProjectIdChanged,
  selectGroupProjectId,
  selectMyProjectId,
  selectStudentProjectId,
  selectStudentUserId,
  studentProjectIdChanged,
} from '../../../features/analysisSlice';
import { useLocation } from 'react-router-dom';
import { useEffect, RefObject } from 'react';

interface Book {
  type: string;
  item: {
    coverFilePath: string;
    projectId: number;
    title: string;
  };
  itemIndex?: number;
  onClick?: (projectId: number) => void;
  dashSectionRef?: RefObject<HTMLDivElement>;
  name?: string;
}

export default function Book({
  type,
  item,
  itemIndex,
  onClick,
  dashSectionRef,
  name,
}: Book) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const isEbookActivity = pathname.includes('ebook-activity');
  const { coverFilePath, projectId, title } = item;
  const isList = type === 'list';

  const userId = useAppSelector(selectStudentUserId);
  const selectedProjectId = useAppSelector(
    userId
      ? selectStudentProjectId
      : isEbookActivity
      ? selectGroupProjectId
      : selectMyProjectId
  );
  const projectChanged = userId
    ? studentProjectIdChanged
    : isEbookActivity
    ? groupProjectIdChanged
    : myProjectIdChanged;

  const selectProject = () => {
    dispatch(projectChanged(projectId));
    onClick && onClick(projectId);

    if (isList) {
      if (selectedProjectId === projectId) {
        dispatch(projectChanged(0));
        return;
      }

      if (dashSectionRef?.current) {
        setTimeout(() => {
          dashSectionRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };

  useEffect(() => {
    if (!selectedProjectId && itemIndex === 0) {
      dispatch(projectChanged(projectId));
    }
  }, []);

  return (
    <div className={cx('book_items', name)}>
      <div className={cx('cover_area')} title={title} onClick={selectProject}>
        <div className={cx('thum_box')}>
          <img src={coverFilePath} alt={title} />
        </div>
      </div>
      {isList && (
        <h3 className={cx('binfo_title')} title={title}>
          {title}
        </h3>
      )}
    </div>
  );
}
